module.exports = "//static.hsappstatic.net/LoginUI/static-1.16044/img/openai-logo-white.svg"